<template>
    <div class="main-content-area">
        <div class="main-content-toolbar">
            <v-toolbar :height="50" :style="{ flex: '8' }"> <!-- 80% of the space -->
                <v-btn icon="mdi-plus-thick" size="small" variant="text" :disabled="allowAdd == false"
                    @click="addStockContainerHandler" v-tippy="{ content: 'Add a new container' }"></v-btn>
                <v-btn icon="mdi-pencil" size="small" variant="text" :disabled="allowEdit == false" @click="editRecord"
                    v-tippy="{ content: 'Edit selected container' }"></v-btn>
                <v-btn v-if="store.user.permissions.includes('System Root/Stock List/Soft Delete Entries-Read')"
                    icon="mdi-delete" size="small" variant="text" :disabled="allowDelete == false" @click="deleteRecord"
                    v-tippy="{ content: 'Delete selected containers' }"></v-btn>
                <v-btn icon="mdi-reload" size="small" variant="text" :disabled="allowAdd == false"
                    @click="common.reloadHandler(state, data, populateGridWithData)"
                    v-tippy="{ content: 'Reload container list' }"></v-btn>
                <v-btn icon="mdi-printer" size="small" variant="text" :disabled="allowPrint == false"
                    @click="printStockContainer"></v-btn>
                <v-btn icon="mdi-check" size="small" variant="text" :disabled="state.isEditing == 'no'"
                    @click="finishEditingContainer" v-tippy="{ content: 'Finish editing container' }"></v-btn>
                <v-btn icon="mdi-file-delimited-outline" size="small" variant="text" @click="exportCsv"
                    v-tippy="{ content: 'Export container list as CSV file' }"></v-btn>
                <v-btn icon="mdi-download" size="small" variant="text" @click="openStockListExportDialog"
                    v-tippy="{ content: 'Export stock list file (CSV/XLSX)' }"></v-btn>
                <v-btn icon="mdi-archive-marker-outline" size="small" variant="text" @click="exportPositionHistory"
                    v-tippy="{ content: 'Export CSV of position history of the selected container' }"></v-btn>
                <v-menu :close-on-content-click=false transition="none">
                    <template v-slot:activator="{ props }">
                        <v-btn icon="mdi-cog" dark v-bind="props" v-tippy="{ content: 'Show / Hide columns' }"></v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(columnContent, i) in columnDefs" :key="i" active-color="primary"
                            style="cursor:pointer;" @click="toggleColumnVisibility(columnContent)">
                            <template v-slot:prepend>
                                <v-icon v-show="isColumnHidden(columnContent)" large color="#4E6F8E"
                                    style="margin-right: 15px;">mdi-checkbox-blank-circle-outline</v-icon>
                                <v-icon v-show="!isColumnHidden(columnContent)" large color="#4E6F8E"
                                    style="margin-right: 15px;">mdi-checkbox-marked-circle</v-icon>
                                <div style="font-size: 14px;"
                                    v-html="columnContent.headerName != '' ? columnContent.headerName : columnContent.headerComponentParams.template">
                                </div>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn icon="mdi-history" size="small" variant="text" :disabled="allowEdit == false" @click="showHistory"
                    v-tippy="{ content: 'Show change history of the containers' }"></v-btn>
                <v-btn icon="mdi-truck-delivery" size="small" variant="text" v-tippy="{ content: 'Gate-In Container' }"
                    :disabled="allowEdit == false || allowedGate != 'in'" @click="gateContainers('in')"></v-btn>
                <v-btn icon="mdi-truck-delivery" size="small" variant="text" style="transform: scaleX(-1)"
                    v-tippy="{ content: 'Gate-Out Container' }" :disabled="allowEdit == false || allowedGate != 'out'"
                    @click="gateContainers('out')"></v-btn>
                <v-btn v-if="store.user.permissions.includes('System Root/Stock List/View Deleted-Read')"
                    :icon="filterRecords ? 'mdi-filter-remove-outline' : 'mdi-filter-check-outline'" size="small"
                    variant="text" @click="toggleFilter"
                    v-tippy="{ content: filterRecords ? 'Include deleted containers' : 'Exclude deleted containers' }"></v-btn>
                <v-btn icon="mdi-receipt-send" size="small" variant="text" :disabled="!allowSendGateInReceipt"
                    @click="sendGateInReceipt" v-tippy="{ content: 'Send/Resend Gate-In receipt to customer' }"></v-btn>
                <v-btn icon="mdi-receipt-send-outline" class="flip-horizontal" size="small" variant="text"
                    :disabled="!allowSendGateOutReceipt" @click="sendGateOutReceipt"
                    v-tippy="{ content: 'Send/Resend Gate-Out receipt to customer' }"></v-btn>
                <v-btn icon="mdi-step-backward" size="small" variant="text" :disabled="allowRevert == false"
                    v-tippy="{ content: (selectedContainerStatus == 2 || selectedContainerStatus == 7) ? 'Revert Gate-In' : 'Revert Gate-Out' }"
                    @click="revertGateInOut"></v-btn>
                <v-btn icon="mdi-message-outline" size="small" variant="text" :disabled="!hasEdiMessages"
                    v-tippy="{ content: 'Show EDI Messages' }" @click="showEdiMessages"></v-btn>
                <v-btn icon="mdi-message-arrow-right-outline" size="small" variant="text"
                    :disabled="!sendGateInEdiMessage" v-tippy="{ content: 'Send/Resend Gate-In Message' }"
                    @click="resendGateInMessage"></v-btn>
                <v-btn icon="mdi-message-arrow-left-outline" size="small" variant="text"
                    :disabled="!sendGateOutEdiMessage" v-tippy="{ content: 'Send/Resend Gate-out Message' }"
                    @click="resendGateOutMessage"></v-btn>
                <v-btn icon="mdi-file-refresh-outline" size="small" variant="text"
                    :disabled="!canRegenerateGateInPdf" v-tippy="{ content: 'Regenerate Gate-In PDF' }"
                    @click="regenerateGateInPdf"></v-btn>
                <v-btn icon="mdi-file-refresh" size="small" variant="text"
                    :disabled="!canRegenerateGateOutPdf" v-tippy="{ content: 'Regenerate Gate-Out PDF' }"
                    @click="regenerateGateOutPdf"></v-btn>
                <v-btn icon="mdi-import" size="small" variant="text"
                    v-tippy="{ content: 'Import Containers From Depot' }"
                    @click="state.showImportContainersConfirmation = true"></v-btn>
                <ConfirmDialog
                :show="state.showImportContainersConfirmation"
                message="Are you sure you want to import containers from the depot?"
                @confirm="importContainersFromDepot"
                @cancel="state.showImportContainersConfirmation = false"
                />

                <v-btn
                    v-if="store.user.permissions.includes('System Root/Stock List/Match Report-Read')"
                    icon="mdi-table-column-plus-after"
                    size="small"
                    variant="text"
                    @click="openMatchedReportsModal"
                    :disabled="!selectedContainer"
                    v-tippy="{ content: 'See matchable reports' }">
                </v-btn>
                <MatchedReports
                :show="state.matchedReportsModalOpen"
                :selectedContainer="selectedContainer"
                :modelSubmodelMap="modelSubmodelMap"
                @close="closeMatchedReportsModal"
                @update:selectedContainer="updateSelectedContainer"
                />

                <v-btn 
                    v-if="store.user.permissions.includes('System Root/Stock List/Unmatch Report-Write')"
                    icon="mdi-table-column-remove"
                    size="small"
                    variant="text"
                    :disabled="!selectedContainer || selectedContainer?.report === null"
                    v-tippy="{ content: 'Unmatch report' }"
                    @click="state.unmatchReportConfirmation = true">
                </v-btn>
                <ConfirmDialog
                :show="state.unmatchReportConfirmation"
                message="Are you sure you want to unmatch report from this container?"
                @confirm="() => { unmatchReport(); state.unmatchReportConfirmation = false }"
                @cancel="state.unmatchReportConfirmation = false"
                />

            </v-toolbar>

            <v-toolbar :height="50" :style="{ flex: '2' }"> <!-- 80% of the space -->
                <v-btn icon="mdi-help-circle" size="small" variant="text"
                    v-tippy="{ content: 'Activate help system. <br>[ Development in progress ]' }"></v-btn>
                <AppNotifications />
            </v-toolbar>
        </div>
        <div class="main-content-playground">
            <!--Id is important for the few jquery selects that we are doing below in order not to affect another grid-->
            <ag-grid-vue id="stockGrid" ref="stockGrid" style="width: 100%; height: 100%;" class="ag-theme-alpine"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="data.rowData"
                :pinnedTopRowData="data.pinnedTopRowData" :gridOptions="gridOptions" :editType="editType"
                @contextmenu="stopEditingOnRightclick">
            </ag-grid-vue>
        </div>

        <div class="main-content-footer">
            <div class="footer-left">
                <v-btn-toggle
                    background-color="primary"
                    v-model="containerTypes"
                    borderless
                    multiple
                    divided
                    mandatory
                    color="primary"
                    style="height:26px;"
                    @update:modelValue="changeContainerTypes"
                    >
                    <v-btn v-if="store.user.permissions.includes('System Root/Yamax/Stock List/Show Preannounced-Read')"
                        value="Preannounced" size='small'>
                        <span class="hidden-sm-and-down">Announced</span>
                    </v-btn>
                    <v-btn value="In Stock" size='small'>
                        <span class="hidden-sm-and-down">In Stock</span>
                    </v-btn>
                    <v-btn value="Released" size='small'>
                        <span class="hidden-sm-and-down">Released</span>
                    </v-btn>
                </v-btn-toggle>
            </div>
            <div class="footer-center">
                <AppMessageNotifications v-if="!state.infiniteDataLoading" />
                <SpinnerComponent v-if="state.infiniteDataLoading"/>
            </div>
            <div class="footer-right">
                {{ filterRecords ? 'Containers' : 'Containers (with deleted)' }}: {{ totalRecords }} out of {{ state.totalRowCount }}
            </div>
        </div>

        <DialogNeo dialog-title="Confirm" :show="state.dialog" dialog-width="25%" dialog-height="unset">
            <template #content>
                <v-container>
                    <v-row align="center">
                        <v-col>
                            Are you sure you want to delete the selected containers?
                            <div v-for="(item, index) in state.nodesToDelete" :key="index">
                                <!--{{ item.data.reference }}-->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row align="end" justify="center">
                        <v-col align="right">
                            <v-btn color="primary" prepend-icon="mdi-delete" @click="cancelDeleteRecord">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Cancel
                            </v-btn>
                            <v-btn color="error" prepend-icon="mdi-delete" @click="confirmDeleteRecord"
                                style="margin-left: 15px;">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                Delete
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text" @click="cancelDeleteRecord"></v-btn>
            </template>
        </DialogNeo>

        <DialogNeo :dialog-title="'Confirm Gate-' + (state.gateType == 'in' ? 'In' : 'Out')" :show="state.dialogGate"
            dialog-width="25%" dialog-height="unset">
            <template #content>
                <v-container>
                    <v-row align="center" style="height: 100%;">
                        <v-col>
                            <v-btn color="primary" prepend-icon="mdi-plus-circle" width="100%"
                                @click="confirmGateContainers(true)">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                WITH - stacker job
                            </v-btn>
                        </v-col>
                        <v-col>
                            <v-btn color="primary" prepend-icon="mdi-minus-circle" width="100%"
                                @click="confirmGateContainers(false)">
                                <template v-slot:prepend>
                                    <v-icon color="white"></v-icon>
                                </template>
                                WITHOUT - stacker job
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text" @click="cancelGateContainers"></v-btn>
            </template>
        </DialogNeo>

        <!--<div style="position:fixed;top:0px;right:0px;left:0;bottom:0;display: flex;flex-direction:column;z-index:1000000;">
            <div>
                <input :value="theValue" type="text" style="width:100%;height:50px;background-color:white;border:1px solid #4E6F8E;"/>
            </div>
            <div style="flex:1;position:relative;">
                <KeypadInput v-model:value="theValue"
                    backdrop="false"
                    :width="'30%'"
                    :height="'30%'"
                    show="true"
                    :all="keypadAllCharacters"
                    :allowed="keypadAllowedList"
                    :characters="4"
                    :characters_from="'end'"
                    :key_layout = "'keypad'"
                    input_selection = "false"
                    @update="updateTheValue"/>
            </div>
        </div>-->

        <DialogNeo v-if="history.dialog === true" :show=true :dialog-header=false :dialog-footer=false dialog-width="90%"
            dialog-height="90%">
            <template #content>
                <HistoryList :history="history" @close="closeHistoryDialog" />
            </template>
        </DialogNeo>

        <DialogNeo v-if="ediList.dialog === true" :show=true :dialog-header=false :dialog-footer=false dialog-width="50%"
            dialog-height="50%">
            <template #content>
                <EdiList :ediList="ediList" @close="closeEdiList" />
            </template>
        </DialogNeo>

        <DialogNeo :dialog-title="'Confirm Gate-' + (state.revertGateType == 'in' ? 'In' : 'Out') + ' Revert'"
            :show="state.revertDialogGate" dialog-width="25%" dialog-height="unset">
            <template #content>
                <v-container>
                    <v-row align="center">
                        <v-col>
                            Are you sure you want to <b>Revert</b> the container <b>{{ state.revertGateType == 'in' ? 'Gate In' : 'Gate Out' }}</b> operation?
                        </v-col>
                    </v-row>
                    <v-row align="end" justify="center">
                        <v-col align="center">
                            <v-btn color="primary" @click="confirmRevertGateInOut()">
                                Ok
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text"
                    @click="state.revertDialogGate = false"></v-btn>
            </template>
        </DialogNeo>

        <DialogNeo dialog-title="Stock List Export" :show="stockListExport.dialog" dialog-width="35%" dialog-height="unset">
            <template #content>
                <v-container class="stock-list-export-form">
                    <v-row>
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Report Type"
                                :items="stockListExportReportTypes"
                                item-title="title"
                                item-value="value"
                                v-model="stockListExport.reportType"
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Facility / Depot"
                                :items="stockListExportFacilityOptions"
                                item-title="name"
                                item-value="id"
                                v-model="stockListExport.filters.facilityIds"
                                multiple
                                clearable
                                chips
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Shipping Line / Operator"
                                :items="stockListExportShippingLineOptions"
                                item-title="name"
                                item-value="id"
                                v-model="stockListExport.filters.shippingLineIds"
                                multiple
                                clearable
                                chips
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Leasing Company"
                                :items="stockListExportLeasingCompanyOptions"
                                item-title="name"
                                item-value="id"
                                v-model="stockListExport.filters.leasingCompanyIds"
                                multiple
                                clearable
                                chips
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Export Type"
                                :items="stockListExportTypes"
                                item-title="title"
                                item-value="value"
                                v-model="stockListExport.exportType"
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="stockListExport.reportType === 'gate_in_out_moves'">
                        <v-col cols="12" class="stock-list-export-field">
                            <v-select
                                class="stock-list-export-input"
                                label="Gate In/Out Date Filter"
                                :items="stockListGateDateFilterModes"
                                item-title="title"
                                item-value="value"
                                v-model="stockListExport.gateDateFilterMode"
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="
                            stockListExport.reportType === 'gate_in_out_moves'
                            && stockListExport.gateDateFilterMode === 'day'
                        "
                    >
                        <v-col cols="12" class="stock-list-export-field">
                            <v-text-field
                                class="stock-list-export-input"
                                label="Gate In/Out Day"
                                type="date"
                                v-model="stockListExport.gateDate"
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="
                            stockListExport.reportType === 'gate_in_out_moves'
                            && stockListExport.gateDateFilterMode === 'month'
                        "
                    >
                        <v-col cols="12" class="stock-list-export-field">
                            <v-text-field
                                class="stock-list-export-input"
                                label="Gate In/Out Month"
                                type="month"
                                v-model="stockListExport.gateMonth"
                                density="compact"
                                variant="outlined"
                            />
                        </v-col>
                    </v-row>
                    <v-row class="stock-list-export-actions" justify="space-between">
                        <v-col cols="auto">
                            <v-btn variant="text" @click="resetStockListExportFilters">Clear</v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn variant="text" @click="closeStockListExportDialog">Cancel</v-btn>
                            <v-btn
                                color="primary"
                                class="ml-2"
                                :loading="stockListExport.isDownloading"
                                @click="downloadStockListExport"
                            >
                                Export
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template #dialog-header-right>
                <v-btn icon="mdi-close-thick" size="small" variant="text" @click="closeStockListExportDialog"></v-btn>
            </template>
        </DialogNeo>

    </div>
</template>

<script setup>

//IMPORTS
import jQuery from "jquery";
import { inject, toRaw, ref, nextTick, reactive, onActivated, onDeactivated, onMounted, onBeforeMount, getCurrentInstance, computed } from 'vue'
import { useAppStore } from '@/stores/app'
import GridTooltip from '@/components/aggrid/GridTooltip'
import { useUtilities } from '@/composables/useUtilities';
import { jsPDF } from "jspdf";
import { useStockListDefinition } from '@/components/aggrid/definitions/useStockListDefinition';
import { useCommon } from '@/components/aggrid/common/useCommon';
import { useRouter } from 'vue-router';
import { useAdvancedAxios } from '@/composables/useAdvancedAxios';
import { AgGridVue } from "ag-grid-vue3";
import { useKeyboard } from '@/composables/useKeyboard';
import _ from 'lodash';
import KeypadInput from '@/components/ui/KeypadInput';
import HistoryList from '@/components/HistoryList';
import EdiList from '@/components/EdiList';

const theValue = ref(1);
const updateTheValue = (data) => {
    theValue.value = data.value;
}


//REFERENCES
const stockGrid = ref(null);



//INJECTIONS
const axios = inject('axios');
const dayJs = inject("dayJs")
const router = useRouter();



//VARIABLES
let gridApi = null;
let gridApi2 = ref(null);
let columnApi = null;
let columnApi2 = ref(null);
let deactivatingCellEditors = false;



//CONSTANTS
const componentId = getCurrentInstance().uid;
const fields = {
    'stockContainers': [
        'id', 'stock_container_status_id', 'blocked', 'unit_number', 'iso_code', 'construction_year', 'depot_id', 'matched_shipping_line', 'matched_leasing_company', 'gate_in_date', 'turn_in_reference',
        'ib_actual_visit_mode', 'inbound_carrier_id', 'ib_actual_visit', 'gate_out_date', 'booking_number', 'ob_actual_visit_mode', 'outbound_carrier_id',
        'ob_actual_visit', 'color', 'floor', 'temperature', 'humidity', 'ventilation', 'comment', 'crun_id', 'created_at', 'updated_at', 'system',
        'position', 'condition', 'grade_id', 'stacking_indicator', 'real_owner', 'technical_state_subcategory'
    ]
};
const $ = jQuery;
const store = useAppStore()
const editType = 'fullRow';
const components = {
    AgGridVue
};
const data = reactive({
    rowData: null,
    pinnedTopRowData: [],
    pinnedBottomRowData: []
})
const buffer = 500;
const pageSize = 1000;

const state = reactive({
    allowUnpin: false,
    isEditing: 'no',
    dialog: false,
    dialogGate: false,
    revertDialogGate: false,
    gridReady: false,
    document: null,
    gateType: null,
    revertGateType: null,
    startRow: 0,
    endRow: pageSize, // Initial page size, adjust as needed
    rowData: [], // Holds the current grid data
    filterModel: {}, // Holds the current filter state
    sortModel: {}, // Holds the current sort state
    totalRowCount: 0, //
    infiniteDataLoading: false,
    matchedReportsModalOpen: false,
    showImportContainersConfirmation: false,
    unmatchReportConfirmation: false,
    previousFilterModel: {} // Store previous filter model state
})
//const keypadSelection=ref(['Jonny bon Jovi', 'Ion cu Doua', 'Superman', 'Batman']);
//const keypadAllCharacters=ref(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]);
//const keypadAllCharacters=ref(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A","B","C","D","E","F","G","H","I","J","K","L","M", "T"]);
const keypadAllCharacters = ref(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]);
const keypadAllowedList = ref(['121123', '111']);
const allowedGate = ref('none');
const triggerButtonsUpdate = ref(true);
const filterRecords = ref(true);
const totalRecords = ref('...');
const stockListPreferencesKey = 'stockList';
const stockListSessionPreferencesKeyPrefix = 'yamaxSession:stockList';
let applyingStockListPreferences = false;
let applyingStockListSessionFilters = false;
let canPersistStockListPreferences = false;
let stockListPreferencesApplied = false;
let pendingStockListPreferenceSave = false;
let userTouchedStockListColumns = false;
let pendingStockListColumnState = [];
let pendingStockListColumnStateUpdatedAt = 0;
const stockListColumnVisibilityVersion = ref(0);

const refreshStockListColumnVisibility = () => {
    stockListColumnVisibilityVersion.value += 1;
};

const normalizeStockListSessionContainerTypes = (value) => {
    const normalized = Array.isArray(value)
        ? value.filter((item) => typeof item === 'string' && item !== '')
        : (typeof value === 'string' && value !== '' ? [value] : []);

    return normalized.length > 0 ? normalized : ['In Stock'];
};

const getStockListSessionPreferenceKey = () => {
    return `${stockListSessionPreferencesKeyPrefix}:${store.user.id ?? 'guest'}`;
};

const getDefaultStockListSessionPreferences = () => {
    return {
        filterModel: {},
        filterRecords: true,
        containerTypes: ['In Stock'],
    };
};

const getStockListSessionPreferences = () => {
    if (!store.user.id) {
        return getDefaultStockListSessionPreferences();
    }

    try {
        const raw = sessionStorage.getItem(getStockListSessionPreferenceKey());
        if (!raw) {
            return getDefaultStockListSessionPreferences();
        }

        const parsed = JSON.parse(raw);
        return {
            filterModel: _.isPlainObject(parsed?.filterModel) ? parsed.filterModel : {},
            filterRecords: typeof parsed?.filterRecords === 'boolean' ? parsed.filterRecords : true,
            containerTypes: normalizeStockListSessionContainerTypes(parsed?.containerTypes),
        };
    } catch (error) {
        return getDefaultStockListSessionPreferences();
    }
};

const saveStockListSessionPreferences = () => {
    if (!store.user.id) {
        return;
    }

    try {
        sessionStorage.setItem(getStockListSessionPreferenceKey(), JSON.stringify({
            filterModel: gridApi ? gridApi.getFilterModel() : {},
            filterRecords: !!filterRecords.value,
            containerTypes: normalizeStockListSessionContainerTypes(containerTypes.value),
        }));
    } catch (error) {
        // ignore sessionStorage errors
    }
};

const applySavedStockListSessionPreferences = () => {
    if (!gridApi) {
        return;
    }

    const savedPreferences = getStockListSessionPreferences();
    const previousFilterModel = gridApi.getFilterModel();
    const hadSavedFilterModel = Object.keys(savedPreferences.filterModel).length > 0;
    const filterRecordsChanged = filterRecords.value !== savedPreferences.filterRecords;
    const containerTypesChanged = JSON.stringify(normalizeStockListSessionContainerTypes(containerTypes.value))
        !== JSON.stringify(savedPreferences.containerTypes);

    filterRecords.value = savedPreferences.filterRecords;
    containerTypes.value = savedPreferences.containerTypes;
    state.previousFilterModel = _.cloneDeep(savedPreferences.filterModel);

    if (hadSavedFilterModel && JSON.stringify(previousFilterModel) !== JSON.stringify(savedPreferences.filterModel)) {
        applyingStockListSessionFilters = true;
        gridApi.setFilterModel(savedPreferences.filterModel);
        setTimeout(() => {
            applyingStockListSessionFilters = false;
        }, 0);
        return;
    }

    if (filterRecordsChanged || containerTypesChanged) {
        updatePaginationParams(0, pageSize);
        populateGridWithData(false);
    }
};

const getLocalStoragePreferenceKey = () => {
    return `stockListColumnState:${store.user.id}`;
};

const saveStockListColumnStateToLocalStorage = (columnState, updatedAt = Date.now()) => {
    if (!store.user.id) {
        return;
    }

    try {
        const payload = {
            columnState,
            updatedAt,
        };
        localStorage.setItem(
            getLocalStoragePreferenceKey(),
            JSON.stringify(payload)
        );
    } catch (error) {
        // ignore localStorage errors
    }
};

const getStockListColumnStateFromLocalStorage = () => {
    if (!store.user.id) {
        return {
            columnState: [],
            updatedAt: 0,
        };
    }

    try {
        const state = JSON.parse(localStorage.getItem(getLocalStoragePreferenceKey()) || '[]');
        if (Array.isArray(state)) {
            return {
                columnState: state,
                updatedAt: 0,
            };
        }

        const columnState = Array.isArray(state?.columnState) ? state.columnState : [];
        const updatedAt = Number(state?.updatedAt || 0);
        return {
            columnState,
            updatedAt: Number.isFinite(updatedAt) ? updatedAt : 0,
        };
    } catch (error) {
        return {
            columnState: [],
            updatedAt: 0,
        };
    }
};

const updatePaginationParams = (start, end) => {
    state.startRow = start;
    state.endRow = end;
};

const containerTypes = ref('In Stock');
const stockListExport = reactive({
    dialog: false,
    isDownloading: false,
    reportType: 'stock_list',
    exportType: 'xlsx',
    gateDateFilterMode: 'none',
    gateDate: dayJs().format('YYYY-MM-DD'),
    gateMonth: dayJs().format('YYYY-MM'),
    filters: {
        facilityIds: [],
        shippingLineIds: [],
        leasingCompanyIds: [],
    },
});
const stockListExportReportTypes = [
    { title: 'Stock List', value: 'stock_list' },
    { title: 'Gate In/Out Moves Overview', value: 'gate_in_out_moves' },
];
const stockListExportTypes = [
    { title: 'CSV', value: 'csv' },
    { title: 'Excel (XLSX)', value: 'xlsx' },
];
const stockListGateDateFilterModes = [
    { title: 'None', value: 'none' },
    { title: 'Day', value: 'day' },
    { title: 'Month', value: 'month' },
];


//COMPUTED
const allowAdd = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowAdd(data, gridApi, state);
})
const allowEdit = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowEdit(data, gridApi, state);
})
const allowDelete = computed(() => {
    let t = triggerButtonsUpdate.value;
    return common.allowDelete(data, gridApi, state);
})
const allowPrint = computed(() => {
    let t = triggerButtonsUpdate.value;
    let rows = gridApi ? gridApi.getSelectedNodes() : 0;
    return rows.length == 1 ? true : false;
})
const allowSendGateInReceipt = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    for (let i = 0; i < total; i++) {
        if (nodes[i].data.stock_container_status_id != 2 && nodes[i].data.stock_container_status_id != 5) {
            return false;
        }
    }
    return true;
});
const allowSendGateOutReceipt = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        return node.data.stock_container_status_id == 5 ? true : false;
    } else {
        return false;
    }
});

const hasEdiMessages = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        return (node.data.sent_gate_in_count > 0 || node.data.sent_gate_out_count > 0) ? true : false;
    } else {
        return false;
    }
});

const sendGateInEdiMessage = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        return node.data.stock_container_status_id == 2 ? true : false;
    } else {
        return false;
    }
});

const sendGateOutEdiMessage = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        return node.data.stock_container_status_id == 5 ? true : false;
    } else {
        return false;
    }
});

const canRegenerateGateInPdf = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        // Enable for containers that have been through gate-in process
        return node.data.stock_container_status_id >= 2 ? true : false;
    } else {
        return false;
    }
});

const canRegenerateGateOutPdf = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    if (total == 0) return false;
    if (total == 1) {
        let node = nodes[0];
        // Enable for containers that have been through gate-out process
        return node.data.stock_container_status_id >= 5 ? true : false;
    } else {
        return false;
    }
});

const allowRevert = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return false;
    let rows = gridApi.getSelectedNodes();
    if (rows.length == 1) {
        let row = rows[0];
        if (row.data.stock_container_status_id == 2 || row.data.stock_container_status_id == 7 || row.data.stock_container_status_id == 5 || row.data.stock_container_status_id == 8) {
            if (row.data.stock_container_status_id == 5 && !store.user.permissions.includes('System Root/Yamax/Stock List/Revert Gate Out-Write')) {
                return false;
            }
            return true;
        }
    }
    return false;
});
const selectedContainerStatus = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return null;
    let rows = gridApi.getSelectedNodes();
    if (rows.length == 1 && (rows[0].data.stock_container_status_id == 2 || rows[0].data.stock_container_status_id == 7 || rows[0].data.stock_container_status_id == 5 || rows[0].data.stock_container_status_id == 8)) {
        return rows[0].data.stock_container_status_id;
    } else {
        return null;
    }
});

const selectedContainer = computed(() => {
    let t = triggerButtonsUpdate.value;
    if (!gridApi) return null;
    let rows = gridApi.getSelectedNodes();
    if (rows.length == 1) {
        return rows[0].data;
    } else {
        return null;
    }
});

const stockListExportFacilityOptions = computed(() => getStockListExportOptionsFromColumn('depot_id'));
const stockListExportShippingLineOptions = computed(() => getStockListExportOptionsFromColumn('matched_shipping_line'));
const stockListExportLeasingCompanyOptions = computed(() => getStockListExportOptionsFromColumn('matched_leasing_company'));

const updateSelectedContainer = (updatedContainer) => {
    const rowNode = gridApi.getSelectedNodes()[0];
            if (rowNode) {
                rowNode.setData(updatedContainer);
            }

    };


//COMPOSABLES
const { common } = useCommon(stockGrid, state, gridApi2, columnApi2, data);
const { advancedAxios } = useAdvancedAxios(axios);
const { getStockListDefinition } = useStockListDefinition(store, dayJs);
const { keyboard } = useKeyboard();
const { utilities } = useUtilities(store);

const columnDefs = ref([]);

const getColumnIdentifier = (columnContent) => {
    return columnContent?.colId || columnContent?.field || null;
};

const isColumnHidden = (columnContent) => {
    // Force reevaluation when column visibility changes outside Vue reactivity.
    stockListColumnVisibilityVersion.value;

    const columnId = getColumnIdentifier(columnContent);
    if (!columnId || !columnApi) {
        return !!columnContent?.hide;
    }

    const column = columnApi.getColumn(columnId);
    if (!column) {
        return !!columnContent?.hide;
    }

    return !column.isVisible();
};

const toggleColumnVisibility = (columnContent) => {
    const columnId = getColumnIdentifier(columnContent);
    if (!columnId) {
        return;
    }

    const shouldHide = !isColumnHidden(columnContent);

    if (columnApi) {
        columnApi.applyColumnState({
            state: [{ colId: columnId, hide: shouldHide }],
            applyOrder: false,
        });
    } else {
        columnContent.hide = shouldHide;
        refreshStockListColumnVisibility();
    }
};

const syncColumnDefsWithColumnState = (columnState) => {
    if (!Array.isArray(columnDefs.value) || !Array.isArray(columnState)) {
        return;
    }

    const orderByColId = new Map(
        columnState
            .filter(item => item && item.colId)
            .map((item, index) => [item.colId, index])
    );

    const stateByColId = new Map(
        columnState
            .filter(item => item && item.colId)
            .map(item => [item.colId, item])
    );

    columnDefs.value.forEach((columnDef) => {
        const colId = columnDef.colId || columnDef.field;
        if (!colId) {
            return;
        }

        const currentColumnState = stateByColId.get(colId);
        if (!currentColumnState || typeof currentColumnState.hide === 'undefined') {
            return;
        }

        columnDef.hide = !!currentColumnState.hide;
    });

    // Keep definition order aligned with AG Grid order to avoid order resets
    // when Vue re-renders `columnDefs`.
    columnDefs.value = [...columnDefs.value].sort((left, right) => {
        const leftId = left.colId || left.field;
        const rightId = right.colId || right.field;

        const leftOrder = orderByColId.has(leftId) ? orderByColId.get(leftId) : Number.MAX_SAFE_INTEGER;
        const rightOrder = orderByColId.has(rightId) ? orderByColId.get(rightId) : Number.MAX_SAFE_INTEGER;

        return leftOrder - rightOrder;
    });
};

const history = reactive({
    dialog: false,
    model: 'StockContainer',
    record: null,
    columnDefs: columnDefs,
    prepareRecord: prepareRecord,
    columnDefsOverride: [],
    columnDefsDisables: {}
});

const ediList = reactive({
    dialog: false,
    model: 'StockContainer',
    record: null,
    columnDefs: columnDefs,
    prepareRecord: prepareRecord,
    columnDefsOverride: [],
    columnDefsDisables: {}
});

const defaultColDef = reactive({
    resizable: true,
    editable: true,
    sortable: true,
    filter: true,
    floatingFilter: true,
    suppressMenu: false,        //To be set to true, hides filter in header
    filterParams: {
        debounceMs: 500,
        suppressAndOrCondition: true
    },
    floatingFilterComponentParams: {
        suppressFilterButton: false //To be set to true, hides filter button in floating filter
    },
    tooltipComponent: GridTooltip,
    suppressKeyboardEvent: function (params) {
        let event = params.event;
        let key = event.key;
        let deniedKeys = ['Escape'];
        let suppress = params.editing && deniedKeys.indexOf(key) >= 0;
        return suppress;
    }
})

// Debounce function
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

// Debounce the onFilterChanged function
const debouncedOnFilterChanged = debounce(() => {
    if (applyingStockListSessionFilters) {
        return;
    }

    const currentFilterModel = gridApi.getFilterModel();
    // Check if the filter model has actually changed
    if (JSON.stringify(currentFilterModel) !== JSON.stringify(state.previousFilterModel)) {
        state.previousFilterModel = { ...currentFilterModel }; // Store new state
        saveStockListSessionPreferences();
        updatePaginationParams(0, pageSize);
        populateGridWithData();
        gridApi.ensureIndexVisible(0, 'top');
    }
}, 300);

const getSavedStockListColumnState = () => {
    const remoteColumnState = _.get(store.user.preferences, `${stockListPreferencesKey}.columnState`, []);
    const remoteUpdatedAtRaw = Number(_.get(store.user.preferences, `${stockListPreferencesKey}.updatedAt`, 0) || 0);
    const remoteUpdatedAt = Number.isFinite(remoteUpdatedAtRaw) ? remoteUpdatedAtRaw : 0;
    const localPreference = getStockListColumnStateFromLocalStorage();

    const hasRemoteState = Array.isArray(remoteColumnState) && remoteColumnState.length > 0;
    const hasLocalState = Array.isArray(localPreference.columnState) && localPreference.columnState.length > 0;

    if (hasLocalState && (!hasRemoteState || localPreference.updatedAt > remoteUpdatedAt)) {
        return localPreference.columnState;
    }

    if (hasRemoteState) {
        return remoteColumnState;
    }

    return hasLocalState ? localPreference.columnState : [];
};

const saveStockListColumnState = _.debounce(() => {
    if (applyingStockListPreferences || !canPersistStockListPreferences) {
        return;
    }

    if (!Array.isArray(pendingStockListColumnState) || pendingStockListColumnState.length === 0) {
        return;
    }

    const preferencesPatch = {
        [stockListPreferencesKey]: {
            columnState: pendingStockListColumnState,
            updatedAt: pendingStockListColumnStateUpdatedAt
        }
    };

    const currentStockListPreferences = _.get(store.user.preferences, stockListPreferencesKey, {});
    store.user.preferences = {
        ...store.user.preferences,
        [stockListPreferencesKey]: {
            ...currentStockListPreferences,
            ...preferencesPatch[stockListPreferencesKey]
        }
    };

    axios.put('/api/user/preferences', {
        preferences: preferencesPatch
    }).catch(() => {
        store.addNotificationMessage('Could not save stock list column preferences.', 'error');
    });
}, 600);

const onColumnPreferencesChanged = () => {
    if (applyingStockListPreferences) {
        return;
    }

    if (!columnApi) {
        return;
    }

    pendingStockListColumnState = columnApi.getColumnState();
    pendingStockListColumnStateUpdatedAt = Date.now();
    saveStockListColumnStateToLocalStorage(
        pendingStockListColumnState,
        pendingStockListColumnStateUpdatedAt
    );
    syncColumnDefsWithColumnState(pendingStockListColumnState);

    refreshStockListColumnVisibility();

    if (!canPersistStockListPreferences) {
        pendingStockListPreferenceSave = true;
        return;
    }

    pendingStockListPreferenceSave = false;
    saveStockListColumnState();
};

const applySavedStockListColumnState = () => {
    if (stockListPreferencesApplied || userTouchedStockListColumns) {
        return;
    }

    const savedColumnState = getSavedStockListColumnState();
    if (!columnApi || savedColumnState.length === 0) {
        return;
    }

    applyingStockListPreferences = true;
    columnApi.applyColumnState({
        state: savedColumnState,
        applyOrder: true
    });
    applyingStockListPreferences = false;
    stockListPreferencesApplied = true;
    pendingStockListColumnState = savedColumnState;
    pendingStockListColumnStateUpdatedAt = Date.now();
    syncColumnDefsWithColumnState(savedColumnState);
    refreshStockListColumnVisibility();
};

const loadStockListPreferences = () => {
    return axios.get('/api/user/preferences', { silent: true })
        .then((response) => {
            const preferences = _.get(response, 'data.preferences', null);
            if (preferences && typeof preferences === 'object') {
                store.user.preferences = preferences;
            }
        })
        .catch(() => {
            // No-op: localStorage fallback still applies.
        });
};

const gridOptions = /*reactive(*/{
    ...common.gridOptions,
    onSortChanged: (e) => {
        //This method keeps the newly added records on top
        common.onSortChanged();
        updatePaginationParams(0, pageSize);
        populateGridWithData();
        gridApi.ensureIndexVisible(0, 'top');
    },
    onCellContextMenu: (params) => {
        //common.onCellContextMenu(params, gridApi, state);
    },
    onFilterChanged: debouncedOnFilterChanged,
    onGridReady: (params) => {
        gridApi = params.api;
        gridApi2.value = params.api;
        columnApi = params.columnApi;
        columnApi2.value = params.columnApi;
        canPersistStockListPreferences = false;
        stockListPreferencesApplied = false;
        pendingStockListPreferenceSave = false;
        userTouchedStockListColumns = false;
        pendingStockListColumnState = [];
        pendingStockListColumnStateUpdatedAt = 0;
        common.onGridReady(params, getStockListDefinition, columnDefs, state, populateGridWithData, true);
        applySavedStockListSessionPreferences();
        loadStockListPreferences().finally(() => {
            setTimeout(() => {
                applySavedStockListColumnState();
                canPersistStockListPreferences = true;
                if (pendingStockListPreferenceSave) {
                    saveStockListColumnState();
                    pendingStockListPreferenceSave = false;
                }
            }, 0);
        });
    },
    onFirstDataRendered: () => {
        applySavedStockListColumnState();
    },
    onColumnMoved: onColumnPreferencesChanged,
    onColumnVisible: onColumnPreferencesChanged,
    onRowEditingStarted: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        common.onRowEditingStarted(params, state, componentId);
    },
    onRowEditingStopped: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    },
    onRowClicked: (params) => {
        if (params.data.id == "") {
            gridApi.startEditingCell({ rowIndex: params.rowIndex, colKey: state.firstVisibleColumn });
        }
    },
    onCellValueChanged(params) {
        common.onCellValueChanged(params, columnApi);
    },
    onRowValueChanged: (params) => {
        if (params.data.id == '' || common.editedRowChanged(state, params.data)) {
            let validation = validateRecord(params);
            if (validation.valid) {
                params.data.valid = true;
                let method = '';
                let url = '/yamax';
                if (params.data.id == '') {
                    method = 'post';
                } else {
                    method = 'put';
                    url += '/' + params.data.id;
                }
                let sendData = { ...params.data };
                //We don't need to send this data
                delete sendData.stock_containers__stock_container;
                delete sendData.depot__company;
                delete sendData.report__report;
                delete sendData.shipping_line__company;

                advancedAxios.sendRequest(componentId + (params.data.id ? params.data.id : params.data.uniqueId), { method: method, url: url, data: sendData })
                    .then(function (response) {
                        if (response.status == 200) {
                            //Update row with changes from backend
                            response.data.model.uniqueId = params.data.uniqueId;
                            response.data.model.valid = true;
                            common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
                            store.addNotificationMessage('Stock Container: <strong>' + (params.data.unit_unmber != '' ? params.data.unit_number : '') + '</strong> saved!', 'success');
                        } else {
                            params.data.valid = false;
                            params.node.setDataValue('valid', false);
                        }
                        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
                    }).catch(function (error) {
                        if (error.message !== 'canceled') {
                            params.data.valid = false;
                            params.node.setDataValue("valid", false);
                        }
                    });
                state.isEditing = 'no';
            } else {
                params.data.valid = false;
                params.node.setDataValue('valid', false);
                store.addNotificationMessage('Reference: <strong>' + params.data.reference + '</strong> has invalid data.\n' + validation.message, 'error');
            }
        }
        state.isEditing = 'no';
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    },

    onSelectionChanged: (params) => {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;

        let nodes = gridApi.getSelectedNodes();
        const total = nodes.length;
        if (total == 1) {
            let node = nodes[0];
            if (node.data.stock_container_status_id == 1) {
                allowedGate.value = 'in';
            } else if (node.data.stock_container_status_id == 2) {
                allowedGate.value = 'out';
            } else {
                allowedGate.value = 'none';
            }
        } else {
            allowedGate.value = 'none';
        }
    },
    onModelUpdated: (params) => {
        totalRecords.value = gridApi ? gridApi.getDisplayedRowCount() : '...';
    },
    onPinnedRowDataChanged: (params) => {
        state.allowUnpin = (data.pinnedTopRowData.length === 0) ? false : true;
    },
    tabToNextCell(params) {
        return common.tabToNextCell(params, gridApi);
    },
    onBodyScroll: (event) => {
        if (!deactivatingCellEditors && event.direction == 'horizontal') {
            deactivatingCellEditors = true;
            common.deactivateAllCellEditors(gridApi);
            setTimeout(function () { deactivatingCellEditors = false; }, 2000);    //We do this so we don't trigger this method too many times and because bodyScrollEnd is not being triggered
        }
        if (data.rowData === null || data?.rowData?.length === state?.totalRowCount){
            return;
        }
        const lastRowIndex = data.rowData.length - 1;

        const gridLastRow = gridApi.getLastDisplayedRow();
        if (state.gridReady && gridLastRow >= lastRowIndex - buffer) {
            state.infiniteDataLoading = true;
            // User scrolled to the bottom, load more data
            const newStartRow = state.endRow;
            const newEndRow = newStartRow + pageSize; // Page size, adjust as needed
            updatePaginationParams(newStartRow, newEndRow);
            populateGridWithData(false);
        }
    },
    onBodyScrollEnd: (event) => {
        //This is currently not working but we will use it once the bug it's fixed by ag-grid developers
        deactivatingCellEditors = false;
    },
    onCellClicked: (params) => {
        common.onCellClicked(params, store);
    }
}



//EVENTS
onBeforeMount(() => { })
onMounted(() => { })
onActivated(() => {
    keyboard.addListener(componentId, onKeyPressHandler);
    keyboard.activate(componentId);
})
onDeactivated(() => {
    saveStockListColumnState.flush();
    saveStockListColumnState.cancel();
    keyboard.removeListener(componentId);
})



//COMPUTED



//METHODS

const closeMatchedReportsModal = () => {
    state.matchedReportsModalOpen = false;
}
const openMatchedReportsModal = () => {
    state.matchedReportsModalOpen = true;
}

const getStockListExportOptionsFromColumn = (fieldName) => {
    const column = columnDefs.value.find(def => def.field === fieldName);
    const valueList = column?.cellEditorParams?.valueList || [];

    return valueList
        .map(item => {
            const id = item?.id ?? item?.value ?? null;
            const name = item?.name ?? item?.label ?? item?.text ?? '';
            if (!id || name === '') {
                return null;
            }

            return {
                id: Number(id),
                name: String(name),
            };
        })
        .filter(Boolean);
};

const openStockListExportDialog = () => {
    stockListExport.dialog = true;
};

const closeStockListExportDialog = () => {
    stockListExport.dialog = false;
};

const resetStockListExportFilters = () => {
    stockListExport.filters.facilityIds = [];
    stockListExport.filters.shippingLineIds = [];
    stockListExport.filters.leasingCompanyIds = [];
    stockListExport.reportType = 'stock_list';
    stockListExport.exportType = 'xlsx';
    stockListExport.gateDateFilterMode = 'none';
    stockListExport.gateDate = dayJs().format('YYYY-MM-DD');
    stockListExport.gateMonth = dayJs().format('YYYY-MM');
};

const getFilenameFromContentDisposition = (contentDisposition, fallbackFilename) => {
    if (!contentDisposition) {
        return fallbackFilename;
    }

    const utf8FilenameMatch = contentDisposition.match(/filename\\*=UTF-8''([^;]+)/i);
    if (utf8FilenameMatch && utf8FilenameMatch[1]) {
        return decodeURIComponent(utf8FilenameMatch[1].replace(/"/g, ''));
    }

    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (filenameMatch && filenameMatch[1]) {
        return filenameMatch[1];
    }

    return fallbackFilename;
};

const normalizeSelectedIds = (values) => {
    const input = Array.isArray(values) ? values : [values];

    return Array.from(
        new Set(
            input
                .map((item) => (typeof item === 'object' && item !== null ? item.id ?? item.value ?? null : item))
                .map((item) => Number(item))
                .filter((item) => Number.isInteger(item) && item > 0)
        )
    );
};

const downloadStockListExport = () => {
    stockListExport.isDownloading = true;

    const facilityIds = normalizeSelectedIds(stockListExport.filters.facilityIds);
    const shippingLineIds = normalizeSelectedIds(stockListExport.filters.shippingLineIds);
    const leasingCompanyIds = normalizeSelectedIds(stockListExport.filters.leasingCompanyIds);

    axios.get('/api/stockContainer/stockListExport', {
        params: {
            reportType: stockListExport.reportType,
            exportType: stockListExport.exportType,
            facilityIds,
            shippingLineIds,
            leasingCompanyIds,
            gateDateFilterMode: stockListExport.gateDateFilterMode,
            gateDate: stockListExport.gateDate,
            gateMonth: stockListExport.gateMonth,
            includeDeleted: !filterRecords.value,
        },
        responseType: 'blob',
    }).then((response) => {
        const extension = stockListExport.exportType === 'csv' ? 'csv' : 'xlsx';
        const filenamePrefix = stockListExport.reportType === 'gate_in_out_moves'
            ? 'stock_list_gate_in_out_moves_export'
            : 'stock_list_export';
        const fallbackFilename = `${filenamePrefix}.${extension}`;
        const filename = getFilenameFromContentDisposition(
            response.headers['content-disposition'],
            fallbackFilename
        );

        const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);

        stockListExport.dialog = false;
        store.addNotificationMessage('Stock list export created successfully.', 'success');
    }).catch((error) => {
        console.error('Error creating stock list export:', error);
        store.addNotificationMessage('Error creating stock list export.', 'error');
    }).finally(() => {
        stockListExport.isDownloading = false;
    });
};



const stopEditingOnRightclick = () => {
    common.stopEditingOnRightClick(state, gridApi);
}

const onKeyPressHandler = (event) => {
    if (event.shiftKey) {
        if (event.key == '+') { addStockContainerHandler(); }
    } else {
        common.onKeyPressHandler(event, gridApi, data, state);
    }
}

const populateGridWithData = (showLoading = true) => {
    state.gridReady = false;
    if (showLoading){
        gridApi.showLoadingOverlay();
        const overlay = document.querySelector('.ag-overlay');
        overlay.style.position = 'absolute';
        overlay.style.top = '97px';
        overlay.style.height = 'calc(100% - 97px)';
        // temporary solution, should be done the correct way
        //this is to show column names and filter inputs while loading
    }

    let filterModel = gridApi.getFilterModel();

    // console.log(filterModel);    // let sortModel = gridApi.getSortModel();
    let columnState = columnApi.getColumnState();
    let sortModel = columnState
    .filter(function (s) {
        return s.sort != null && s.colId !== 'new';
    })
    .reduce(function (acc, s) {
        acc[s.colId] = { sort: s.sort, sortIndex: s.sortIndex };
        return acc;
    }, {});

    let startRow = state.startRow;
    let endRow = state.endRow;

    let cTypes = (containerTypes.value instanceof Array) ? containerTypes.value.join(',') : containerTypes.value;

    let url = `/api/yamax?status=${cTypes}`;
    url += filterRecords.value ? '&deleted=false' : '&deleted=true';
    url += `&startRow=${startRow}&endRow=${endRow}`;
    url += `&filters=${encodeURIComponent(JSON.stringify(filterModel))}`;
    url += `&sort=${encodeURIComponent(JSON.stringify(sortModel))}`;

    common.normalServerReload(url, axios, state, gridApi2, fields, store, modelSubmodelMap, columnDefs, prepareRecord, common.prepareListRecord, data, (response) => {
        // console.log(response);
        state.totalRowCount = response.data.totalRows; // Update total row count from server
        onReloadSuccessError(response);
    }, onReloadSuccessError);
};

const onReloadSuccessError = (response) => {
    state.gridReady = true;
    triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    state.infiniteDataLoading = false;
}

const addStockContainerHandler = () => {
    gridApi.setFilterModel(null);
    setTimeout(function () {
        gridApi.hideOverlay();
        state.isAdding = true;
        let newContainer = prepareRecord({
            new: 1
        });
        data.rowData.unshift(newContainer);
        
        // Use setTimeout to prevent AG Grid rendering conflict
        setTimeout(() => {
        gridApi.setRowData(data.rowData);
        nextTick(() => {
            let node = gridApi.getRowNode(newContainer.uniqueId);
            if (node) {
                gridApi.startEditingCell({ rowIndex: node.rowIndex, colKey: state.firstVisibleColumn });
                state.isEditing = 'existing';
            }
            });
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        }, 0);
    }, 1);
}


//Gate In Containers
const gateContainers = (type) => {
    let nodes = gridApi.getSelectedNodes();
    let nonGateInable = 0;
    const total = nodes.length;
    state.nodesToGate = [];
    nodes.forEach(item => {
        state.nodesToGate.push(item);
    });
    state.gateType = type;
    state.dialogGate = true;
}
const confirmGateContainers = (withJob) => {
    state.dialogGate = false
    let gateData = [];
    let max = state.nodesToGate.length;
    for (let i = 0; i < max; i++) {
        gateData.push(state.nodesToGate[i].data.id);
    }
    axios.post('/stockContainer/' + gateData.join(',') + '/' + (state.gateType == 'in' ? 'gateIn' : 'gateOut') + '/' + (withJob ? 'withJob' : 'withoutJob')).then(function (response) {
        if (response.status === 200) {
            //Update row with changes from backend
            response.data.model.uniqueId = state.nodesToGate[0].data.uniqueId;
            common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
            //
            if (withJob) {
                store.addNotificationMessage("A job was created for container " + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + " and it's going to be gated " + state.gateType + '!', 'success');
            } else {
                store.addNotificationMessage('Container: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' gated ' + state.gateType + '!', 'success');
            }

            state.nodesToGate = [];
        } else {
            state.nodesToGate[0].data.valid = false;
            state.nodesToGate[0].node.setDataValue('valid', false);
            store.addNotificationMessage('Container: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' could not be gated ' + state.gateType + '!\nReason: ' + response.data.message, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;

    }).catch(function (error) { });
}
const cancelGateContainers = () => {
    state.dialogGate = false
}

const revertGateInOut = () => {
    let row;
    let rows = gridApi.getSelectedNodes();
    if (rows.length == 1) {
        row = rows[0];
        if (row.data.stock_container_status_id == 2 || row.data.stock_container_status_id == 7) {
            state.revertGateType = 'in';
        } else if (row.data.stock_container_status_id == 5 || row.data.stock_container_status_id == 8) {
            state.revertGateType = 'out';
        }
    }
    state.revertDialogGate = true;
}
const confirmRevertGateInOut = () => {
    state.revertDialogGate = false;
    let revertType = null;
    let row;
    let rows = gridApi.getSelectedNodes();
    if (rows.length == 1) {
        row = rows[0];
        if (row.data.stock_container_status_id == 2 || row.data.stock_container_status_id == 7) {
            revertType = 'revertGateIn';
        } else if (row.data.stock_container_status_id == 5 || row.data.stock_container_status_id == 8) {
            revertType = 'revertGateOut/returnStockContainer';
        } else {
            return false;
        }
    } else {
        return false;
    }
    let container = row.data;

    let url = '/stockContainer/' + container.id + '/' + revertType;
    advancedAxios.sendRequest(componentId + container.uniqueId, { method: 'post', url: url })
        .then(function (response) {
            if (response.status === 200) {
                if (revertType == 'revertGateIn') {
                    let delIndex = data.rowData.findIndex(o => o.id === parseInt(response.data.model.id));
                    data.rowData.splice(delIndex, 1);
                    gridApi.setRowData(data.rowData);
                } else {
                    response.data.model.uniqueId = container.uniqueId;
                    response.data.model.valid = true;
                    common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
                }
                store.addNotificationMessage((revertType == 'revertGateIn' ? 'Gate-In' : 'Gate Out') + ' reverted for container: ' + (container.unit_number ? container.unit_number : ''), 'success');
            } else {
                store.addNotificationMessage((revertType == 'revertGateIn' ? 'Gate In' : 'Gate Out') + ' for container: ' + (container.unit_number ? container.data.unit_number : '') + ' could not be reverted!\nReason: ' + response.data.message, 'error');
            }
            triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
            //updateGatedContainers();
        }).catch(function (error) {
            //
        });
}

function prepareRecord(item) {
    return {
        ...common.prepareRecord(item)
        ,
        ...{
            valid: true,
            blocked: item.blocked || '0',
            id: item.id || '',
            crun_id: item.crun_id || '',
            turn_in_reference: _.get(item, 'return__reference.reference', '') || '',
            booking_number: _.get(item, 'release__reference.reference', '') || '',
            system: item.system || '',
            unit_number: item.unit_number || '',
            depot_id: item.depot_id || '',
            matched_leasing_company: item.matched_leasing_company || null,
            matched_shipping_line: item.matched_shipping_line || null,
            operator_name: item.operator_name || '',
            iso_code: item.iso_code || '',
            gate_in_date: item.gate_in_date || '',
            gate_out_date: item.gate_out_date || '',
            position: item.position || '',
            construction_year: item.report__report ? item.report__report.construction_year : item.construction_year,
            ib_actual_visit_mode: item.ib_actual_visit_mode || '',
            ib_actual_visit: item.ib_actual_visit || '',
            ob_actual_visit_mode: item.ob_actual_visit_mode || '',
            ob_actual_visit: item.ob_actual_visit || '',
            condition: item.condition ? item.condition : null,
            last_on_hire_date: item.last_on_hire_date || '',
            comment: item.comment || '',
            color: item.color || '',
            floor: item.floor || '',
            temperature: item.temperature || '',
            humidity: item.humidity || '',
            ventilation: item.ventilation || '',
            created_at: item.created_at || '',
            updated_at: item.updated_at || '',
            return__reference: item.return__reference,
            release__reference: item.release__reference,
            depot__company: item.depot__company,
            shipping_line__company: item.shipping_line__company,
            inbound_carrier_id: item.inbound_carrier_id || '',
            outbound_carrier_id: item.outbound_carrier_id || '',
            returning_company_name: item.returning_company_name,
            report__report: item.report__report,
            report: _.get(item, 'report__report.id', null),
            damaged: item.report__report ? getContainerStatus(item.report__report) : '',
            last_gate_in_yamax_task_status: item.last_gate_in_yamax_task__yamax_task ? item.last_gate_in_yamax_task__yamax_task.status : null,
            last_gate_out_yamax_task_status: item.last_gate_out_yamax_task__yamax_task ? item.last_gate_out_yamax_task__yamax_task.status : null,
            stock_container_status_id: item.stock_container_status_id ? item.stock_container_status_id : '',
            receipts: (item.gate_in_job_status_id ? item.gate_in_job_status_id : '') + (item.gate_out_job_status_id ? item.gate_out_job_status_id : ''),
            grade_id: item.grade_id || '',
            stacking_indicator: item.stacking_indicator || '',
            //Without grid columns
            gate_in_job_status_id: item.gate_in_job_status_id ? item.gate_in_job_status_id : null,
            gate_out_job_status_id: item.gate_out_job_status_id ? item.gate_out_job_status_id : null,
            run_state: item.report__report ? (item.report__report.revision__revision ? item.report__report.revision__revision.runState : '') : '',
            sent_gate_in_count: item.sent_gate_in_count,
            sent_gate_out_count: item.sent_gate_out_count,
            document_tag_id: (item.report__report && item.report__report.tag__tag) ? item.report__report.tag__tag.id : '',
            cargo_condition_id: item.report__report ? item.report__report.cargo_condition : '',
            inspection_criteria: item.report__report ? item.report__report.inspection_criteria : '',
            repair_criteria: item.report__report ? item.report__report.repair_criteria : '',
            sale_grade_id: item.report__report ? item.report__report.saleGrade : '',
            shop_location: item.shop_location,
            real_owner: item.real_owner,
            technical_state: item.technical_state_subcategory || '',
        }
    }
}

const getContainerStatus = (report) => {
    if (!report) {
        return 'No Report';
    }

    switch (report.damaged) {
        case 0: return 'Intact';
        case 1: return 'Damaged';
        case 2: return 'Instant Repair';
        default: return 'Unknown Status';
    }
}

const getReportStatus = (report) => {
    if (!report) {
        return 'No Report';
    }

    if (!report.revision__revision) {
        return 'No Revision';
    }
    switch (report.revision__revision.runState) {
        case 1: return 'Awaiting Estimate';
        case 2: return 'Check Report';
        case 3: return 'Survey (Estimate)';
        case 4: return 'Work Order';
        case 5: return 'Survey (Post Repair)';
        case 6: return 'Re-Work Order';
        case 7: return 'Available';
        case 8: return 'Survey (On-Hire)';
        case 9: return 'Release as is';
        case 10: return 'Released';
        case 11: return 'Estimate';
        case 12: return 'Add. Estimate';
        case 13: return 'Survey (Add. Estimate)';
        case 14: return 'Add. Work Order';
        case 15: return 'Pre Delivery Estimate';
        default: return 'Unknown State';
    }
}

const editRecord = () => {
    gridApi.stopEditing();
    let rows = gridApi.getSelectedNodes();
    if (rows.length > 0) {
        let row = rows[0];
        gridApi.startEditingCell({ rowIndex: row.rowIndex, colKey: state.firstVisibleColumn });
        state.isEditing = 'existing';
    }
}
const cancelStockContainer = () => {
    state.dialog = false
}

const deleteRecord = () => {
    if (!common.deleteEditingRow(gridApi, data, state)) {
        let nodes = gridApi.getSelectedNodes();
        let nonDeletable = 0;
        const total = nodes.length;
        state.nodesToDelete = [];
        nodes.forEach(item => {
            state.nodesToDelete.push(item);
        });
        if (nonDeletable > 0) {
            if (total > 1) {
                if (nonDeletable == total) { store.addNotificationMessage("The containers already have a Gate-Out date and can't be deleted", 'warning'); }
                else if (nonDeletable > 0) { store.addNotificationMessage("Some containers already have a Gate-Out date and can't be deleted", 'warning'); }
            } else {
                if (nonDeletable == 1) {
                    store.addNotificationMessage("The container already has a Gate-Out date and can't be deleted", 'warning');
                }
            }
        } else {
            state.dialog = true;
        }
    } else {
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }
}
const confirmDeleteRecord = () => {
    state.dialog = false
    let delData = [];
    let max = state.nodesToDelete.length;
    for (let i = 0; i < max; i++) {
        delData.push(state.nodesToDelete[i].data.id);
    }
    axios.delete('/stockContainer/' + delData.join(',')).then(function (response) {
        if (response.status == 200) {
            let deleted = response.data.deleted.length ? response.data.deleted.split(",") : [];
            let max = deleted.length;
            for (let i = 0; i < max; i++) {
                let delIndex = data.rowData.findIndex(o => o.id === parseInt(deleted[i]));
                data.rowData.splice(delIndex, 1);
                gridApi.setRowData(data.rowData);
            }
            state.nodesToDelete = [];
            triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        }
    }).catch(function (error) { });
}
const cancelDeleteRecord = () => {
    state.dialog = false
}

const finishEditingContainer = (cancel = false) => {
    gridApi.stopEditing();
    state.isEditing = 'no';
    triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
}

const exportCsv = () => {
    common.exportCsv(gridApi, {
        processHeaderCallback: function (params) {
            switch (params.column.colId) {
                case 'report':
                    return 'SC Flow Report';
                default:
                    return params.column.colDef.headerName;
            }
        }
    }, {
        processCellCallback: function (cell) {
            if (cell.column.colId == 'receipts') {
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date == '') {
                    return 'In';
                }
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date != '') {
                    return 'In/Out';
                }
                return false;
            } else {
                return false;
            }
        }
    });
}

const exportXlsx = () => {
    common.exportXlsx(gridApi, {
        fileName: 'export.xlsx',
        processHeaderCallback: function (params) {
            switch (params.column.colId) {
                case 'report':
                    return 'SC Flow Report';
                default:
                    return params.column.colDef.headerName;
            }
        }
    }, {
        processCellCallback: function (cell) {
            if (cell.column.colId == 'receipts') {
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date == '') {
                    return 'In';
                }
                if (cell.node.data.gate_in_date != '' && cell.node.data.gate_out_date != '') {
                    return 'In/Out';
                }
                return false;
            } else {
                return false;
            }
        }
    });
}

const savePdf = () => {
    let nodes = gridApi.getSelectedNodes();
    let data = nodes[0].data;
    let sendData = { document: state.document };
    axios({ method: 'POST', url: '/stockContainer/' + data.id + '/saveGateOutPdf', data: sendData }).then(function (response) {
        if (response.status == 200) {
            triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        }
    });
}

const generatePdf = () => {
    let nodes = gridApi.getSelectedNodes();
    let data = nodes[0].data;
    let sendData = { document: state.document };

    axios({
        method: 'GET',
        url: '/stockContainer/' + data.id + '/generateGateOutPdf',
        responseType: 'arraybuffer',
        data: sendData
    }).then(function (response) {
        if (response.status == 200) {
            let blob = new Blob([response.data], { type: 'application/pdf' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Report.pdf';
            link.click();
            //triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
        }
    })
}

const printStockContainer = () => {
    let nodes = gridApi.getSelectedNodes();

    let data = nodes[0].data;

    const doc = new jsPDF();
    doc.setFont('Arial', 'normal', 'bold');
    doc.setFontSize(12);
    doc.text("Gate-In Verification", 10, 14);
    doc.addImage("assets/maersk.jpg", "JPEG", 160, 12, 35, 19);

    doc.setFont('Arial', 'normal', 'normal');
    doc.setFontSize(11);

    doc.text("Reference No:", 10, 50);
    doc.text("Facility:", 10, 55);
    doc.text("Eir No:", 10, 60);
    doc.text("Container No:", 10, 65);
    doc.text("Gate-In Date:", 10, 70);
    doc.text("Company Name:", 10, 75);
    doc.text("License Plate:", 10, 80);
    doc.text("Inspection Condition:", 10, 85);
    doc.text("Remarks:", 10, 90);
    doc.text("Tracking Link:", 10, 95);

    doc.setFont('Arial', 'normal', 'bold');

    doc.text(data.return__reference ? data.return__reference.reference + '' : '', 50, 50);
    doc.text(data.depot__company ? data.depot__company.name : '', 50, 55);
    doc.text(data.crun_id + '', 50, 60);
    doc.text(data.unit_number + '', 50, 65);
    doc.text(utilities.dateFormatter({ value: data.gate_in_date, format: 'datetime' }), 50, 70);
    doc.text(data.shipping_line__company ? data.shipping_line__company.name : '', 50, 75);
    doc.text(data.ib_actual_visit, 50, 80);
    doc.text(data.comment + '', 50, 90);

    doc.addImage("assets/survey-compass.jpg", "JPEG", 85, 275, 35, 8.75);


    doc.setFont('Arial', 'normal', 'bold');
    doc.setFontSize(9);
    doc.text('Print Date & Time', 167, 115);
    doc.setFont('Arial', 'normal', 'normal');

    let dateObj = new Date();
    let month = dateObj.getUTCMonth() + 1; //months from 1-12
    if (month < 10) { month = "0" + month; }
    let day = dateObj.getUTCDate();
    let year = dateObj.getUTCFullYear();
    let newdate = year + "-" + month + "-" + day + " " + dateObj.getHours() + ":" + dateObj.getMinutes() + ":" + dateObj.getSeconds();

    doc.text(utilities.dateFormatter({ value: newdate, format: 'datetime' }), 167, 120);

    let document = doc.output('datauristring');
    state.document = document;

    doc.save("print.pdf");
}

const changeContainerTypes = (params) => {
    saveStockListSessionPreferences();
    updatePaginationParams(0, pageSize);
    common.reloadHandler(state, data, populateGridWithData, false)
}

const showHistory = () => {
    let rows = gridApi.getSelectedNodes();
    if (rows.length > 0) {
        history.record = rows[0].data;
        history.dialog = true;
    }
}

const showEdiMessages = () => {
    let rows = gridApi.getSelectedNodes();
    if (rows.length > 0) {
        ediList.record = rows[0].data;
        ediList.dialog = true;
    }
}

const resendGateInMessage = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers.join(',') + '/resendEdiGateInMessage').then(function (response) {
        if (response.status === 200) {
            store.addNotificationMessage('Gate-In EDI Message was sent for container ' + nodes[0].data.unit_number, 'success');
        } else {
            store.addNotificationMessage('Failed to send Gate-In EDI Message for container ' + nodes[0].data.unit_number, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) {
        console.error('Error sending Gate-In EDI Message:', error);
        const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : 'An unexpected error occurred';
        store.addNotificationMessage('Error sending Gate-In EDI Message: ' + errorMessage, 'error');
    });
}

const resendGateOutMessage = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers.join(',') + '/resendEdiGateOutMessage').then(function (response) {
        if (response.status === 200) {
            store.addNotificationMessage('Gate-Out EDI Message was sent for container ' + nodes[0].data.unit_number, 'success');
        } else {
            store.addNotificationMessage('Failed to send Gate-Out EDI Message for container ' + nodes[0].data.unit_number, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) {
        console.error('Error sending Gate-Out EDI Message:', error);
        const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : 'An unexpected error occurred';
        store.addNotificationMessage('Error sending Gate-Out EDI Message: ' + errorMessage, 'error');
    });
}

const regenerateGateInPdf = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers[0] + '/regenerateGateInPdf').then(function (response) {
        if (response.status === 200) {
            store.addNotificationMessage('Gate-In PDF regenerated successfully for container ' + nodes[0].data.unit_number, 'success');
        } else {
            store.addNotificationMessage('Failed to regenerate Gate-In PDF for container ' + nodes[0].data.unit_number, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) {
        console.error('Error regenerating Gate-In PDF:', error);
        const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : 'An unexpected error occurred';
        store.addNotificationMessage('Error regenerating Gate-In PDF: ' + errorMessage, 'error');
    });
}

const regenerateGateOutPdf = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers[0] + '/regenerateGateOutPdf').then(function (response) {
        if (response.status === 200) {
            store.addNotificationMessage('Gate-Out PDF regenerated successfully for container ' + nodes[0].data.unit_number, 'success');
        } else {
            store.addNotificationMessage('Failed to regenerate Gate-Out PDF for container ' + nodes[0].data.unit_number, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) {
        console.error('Error regenerating Gate-Out PDF:', error);
        const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : 'An unexpected error occurred';
        store.addNotificationMessage('Error regenerating Gate-Out PDF: ' + errorMessage, 'error');
    });
}

const importContainersFromDepot = () => {
    state.showImportContainersConfirmation = false
    gridApi.showLoadingOverlay(); // Show loading overlay

    axios.get('/api/stockContainer/importFromDepot')
        .then(function (response) {
            if (response.status === 200) {
                let updated = response.data.imported;

                if (updated > 0){
                    store.addNotificationMessage(`${updated} container(s) imported successfully.`, 'success');
                    updatePaginationParams(0, pageSize);
                    populateGridWithData();
                }
                else{
                    store.addNotificationMessage('0 containers were added or updated.', 'info');
                }
            } else {
                store.addNotificationMessage('Import failed! Reason: ' + response.data.message, 'error');
            }
        })
        .catch(function (error) {
            console.error('Error importing containers:', error);
            store.addNotificationMessage('An error occurred while importing containers.', 'error');
        })
        .finally(function () {
            gridApi.hideOverlay(); // Hide the loading overlay after the operation is complete
        });
};

const unmatchReport = () => {
    gridApi.showLoadingOverlay(); // Show loading overlay

    const crunId = selectedContainer.value.crun_id;
    const reportId = selectedContainer.value.report;



    axios.post('/api/stockContainer/unmatchReport', {
          crunId,
          reportId,
        })
        .then(function (response) {
            if (response.status === 200) {
                    store.addNotificationMessage(`Report unmatched successfully.`, 'success');
                    updateSelectedContainer({ ...selectedContainer.value, report: null, report__report: null })
            } else {
                store.addNotificationMessage('Failed! Reason: ' + response.data.message, 'error');
            }
        })
        .catch(function (error) {
            console.error('Error unmatching report:', error);
            store.addNotificationMessage('An error occurred while unmatching report.', 'error');
        })
        .finally(function () {
            gridApi.hideOverlay(); // Hide the loading overlay after the operation is complete
        });
};

const exportPositionHistory = (exportType = 'csv') => {
    let selectedRows = gridApi.getModel().rowsToDisplay;

    if (selectedRows.length > 0) {
        const containerIds = selectedRows.map(row => row.data.id);
        console.log(containerIds);

        // Make a request to the server to get the position history for the selected containers
        axios.post('/api/stockContainer/positionHistory', { containerIds })
            .then(response => {
                const historyData = response.data;
                console.log(historyData);

                if (Array.isArray(historyData) && historyData.length > 0) {
                    const excludedColumns = ['id', 'row_id', 'column'];
                    if (exportType === 'xlsx') {
                        downloadXlsxFile(historyData, excludedColumns, 'position_history.xlsx');
                    } else {
                        const csvContent = convertToCSV(historyData, excludedColumns);
                        downloadCsvFile(csvContent, 'position_history.csv');
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching position history:', error);
                // Handle the error, show a message, etc.
            });
    }
};

function convertToCSV(data, excludedColumns) {
    if (!Array.isArray(data) || data.length < 1) {
        return '';
    }
    const header = [...Object.keys(data[0])].filter(column => !excludedColumns.includes(column)).join(',');

    const rows = data.map(entry => {
        const rowData = Object.entries(entry)
            .filter(([key]) => !excludedColumns.includes(key))
            .map(([, value]) => value)
            .join(',');

        return `${rowData}`;
    });

    return `${header}\n${rows.join('\n')}`;
}

const downloadCsvFile = (csvContent, fileName) => {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
};

const downloadXlsxFile = async (data, excludedColumns, fileName) => {
    const xlsxModule = await import('xlsx');
    const XLSX = xlsxModule.default ? xlsxModule.default : xlsxModule;

    if (!Array.isArray(data) || data.length < 1) {
        return;
    }

    const headers = [...Object.keys(data[0])].filter(column => !excludedColumns.includes(column));
    const rows = data.map(entry => headers.map((header) => entry[header]));

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Position History');

    let name = String(fileName || 'position_history.xlsx');
    if (!name.toLowerCase().endsWith('.xlsx')) {
        name = name + '.xlsx';
    }

    XLSX.writeFile(workbook, name);
};

const closeHistoryDialog = () => {
    history.dialog = false;
}

const closeEdiList = () => {
    ediList.dialog = false;
}

const toggleFilter = () => {
    filterRecords.value = !filterRecords.value;
    saveStockListSessionPreferences();
    common.reloadHandler(state, data, populateGridWithData);
}

const sendGateInReceipt = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers.join(',') + '/sendGateInReceipt').then(function (response) {
        if (response.status === 200) {

            console.log('Response');
            console.log(response);

            //Update row with changes from backend
            /*response.data.model.uniqueId = state.nodesToGate[0].data.uniqueId;
            common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
            //
            if (withJob){
                store.addNotificationMessage("A job was created for container " + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + " and it's going to be gated " + state.gateType+'!', 'success');
            }else{
                store.addNotificationMessage('Container: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' gated ' + state.gateType+'!', 'success');
            }

            state.nodesToGate = [];*/
            store.addNotificationMessage('Gate-In receipt was scheduled for sending', 'success');
        } else {
            store.addNotificationMessage('Containers: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' could not be gated ' + state.gateType + '!\nReason: ' + response.data.message, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) { });
}

const sendGateOutReceipt = () => {
    let containers = [];
    let nodes = gridApi.getSelectedNodes();
    const total = nodes.length;
    for (let i = 0; i < total; i++) {
        containers.push(nodes[i].data.id);
    }
    axios.post('/stockContainer/' + containers.join(',') + '/sendGateOutReceipt').then(function (response) {
        if (response.status === 200) {

            console.log('Response');
            console.log(response);

            //Update row with changes from backend
            /*response.data.model.uniqueId = state.nodesToGate[0].data.uniqueId;
            common.updateChangesFromBackendOnUpdatingRows(response.data.model, gridApi, data, prepareRecord);
            //
            if (withJob){
                store.addNotificationMessage("A job was created for container " + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + " and it's going to be gated " + state.gateType+'!', 'success');
            }else{
                store.addNotificationMessage('Container: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' gated ' + state.gateType+'!', 'success');
            }

            state.nodesToGate = [];*/
            store.addNotificationMessage('Gate-Out receipt was scheduled for sending', 'success');
        } else {
            store.addNotificationMessage('Containers: ' + (state.nodesToGate[0].data.unit_number ? state.nodesToGate[0].data.unit_number : '') + ' could not be gated ' + state.gateType + '!\nReason: ' + response.data.message, 'error');
        }
        triggerButtonsUpdate.value = !triggerButtonsUpdate.value;
    }).catch(function (error) { });
}

const validateRecord = (params) => {
    let ret = {
        valid: true,
        message: ''
    };

    ret.valid = true;
    return ret;
}

const modelSubmodelMap = {
    model: {
        'stockContainers': { target: function () { if (data.rowData === null) { data.rowData = []; } return data.rowData } }
    },
    submodels: {
        'matched_shipping_line': { target: function () { return columnDefs.value.find(def => def.field === 'matched_shipping_line') } },
        'depot_id': { target: function () { return columnDefs.value.find(def => def.field === 'depot_id') } },
        'matched_leasing_company': { target: function () { return columnDefs.value.find(def => def.field === 'matched_leasing_company') } },
        'ib_actual_visit_mode': { target: function () { return columnDefs.value.find(def => def.field === 'ib_actual_visit_mode') } },
        'ob_actual_visit_mode': { target: function () { return columnDefs.value.find(def => def.field === 'ob_actual_visit_mode') } },
        'condition': { target: function () { return columnDefs.value.find(def => def.field === 'condition') } },
        'iso_code': { id: 'code', name: ['code', 'survey_type__survey_type.name'], prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'iso_code').cellEditorParams.valueList } },
        'inbound_carrier_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'inbound_carrier_id').cellEditorParams.valueList } },
        'outbound_carrier_id': { prepareRecord: common.prepareListRecord, target: function () { return columnDefs.value.find(def => def.field === 'outbound_carrier_id').cellEditorParams.valueList } },
        'color': { target: function () { return columnDefs.value.find(def => def.field === 'color') } },
        'run_state': { target: function () { return columnDefs.value.find(def => def.field === 'run_state') } },
        'floor': { target: function () { return columnDefs.value.find(def => def.field === 'floor') } },
        'stock_container_status_id': { target: function () { return columnDefs.value.find(def => def.field === 'stock_container_status_id') } },
        'cargo_condition_id': { id: 'code', target: function () { return columnDefs.value.find(def => def.field === 'cargo_condition_id') } },
        'inspection_criteria': { target: function () { return columnDefs.value.find(def => def.field === 'inspection_criteria') } },
        'document_tag_id': { target: function () { return columnDefs.value.find(def => def.field === 'document_tag_id') } },
        'sale_grade_id': { target: function () { return columnDefs.value.find(def => def.field === 'sale_grade_id') } },
    }
};

</script>

<script>
export default {
    name: 'StockList',
    customOptions: {}
}
</script>

<style scoped>
.main-content-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 50px;
    padding: 12px 16px;
    border-top: 1px solid #babfc7;
    background-color: #f8f8f8;
    z-index: 2;
}

.footer-left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 250px;
    gap: 8px;
}

.footer-center {
    display: none;
}

.footer-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 250px;
}

.stock-list-export-form {
    padding-top: 10px;
}

.stock-list-export-field {
    padding-top: 6px;
    padding-bottom: 6px;
}

.stock-list-export-input :deep(.v-field) {
    border-radius: 4px;
}

.stock-list-export-input :deep(.v-field__input) {
    align-items: center;
    min-height: 44px;
}

.stock-list-export-input :deep(.v-select__selection) {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.stock-list-export-input :deep(.v-chip) {
    margin-inline-end: 6px;
    margin-bottom: 4px;
}

.stock-list-export-actions {
    margin-top: 6px;
}

v-btn::active {
    background-color: #2b5c8b !important;
    color: #FFFFFF !important;
}
</style>
